<template>
    <div class="appoint-cont">
        <el-form label-position="right" :rules="rules" label-width="110px" ref="appointForm" :model="appointData">
            <el-form-item label="预约取件时间" :required="true">
                <div class="row-item">
                    <el-form-item prop="appointmentTime" :rules="[
                        { required: true, message: '请选择取件日期', trigger: 'change' }
                    ]">
                        <el-date-picker v-model="appointData.appointmentTime" class="appoint-date"
                            value-format="yyyy-MM-dd" placeholder="预约取件日期" type="date"
                            :picker-options="pickerOptions" :clearable="false" @change="changeAppointmentTime"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="appointmentTimeSlot" class="row-item-ml">
                        <el-select v-model="appointData.appointmentTimeSlot" placeholder="预约取件时间" clearable
                            @change="changeVal">
                            <el-option v-for="item in timeSlotOptions" :key="item.value" :value="item.value" :label="item.label" :disabled="delieveryTimeSlotDisabled(item)"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form-item>
            <el-form-item label="改约原因" :rules="[
                        { required: requiredAppointReason, message: '请选择改约原因', trigger: 'change' }
                    ]" prop="appointmentChangeFirstReasonType">
                <div class="flex-box">
                    <el-cascader clearable class="appoint-reason"
                        v-model="appointData.appointReasons"
                        :options="appointReasonOptions"
                        @change="changeAppointReasons">
                    </el-cascader>
                </div>
            </el-form-item>
            <el-form-item label="备注" class="task-appoint-form-item"  prop="remark"
            :rules="[{ required: propertiesList, message: '请填写备注原因', trigger: 'change' }]">
                <el-input type="text" v-model="appointData.remark" clearable maxlength="500" show-word-limit />
            </el-form-item>
            <el-form-item label="附件" prop="propertiesList">
                <attachment-upload
                    ref="receiptUpload"
                    :propertiesList="appointData.propertiesList"
                ></attachment-upload>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import dayjs from 'dayjs';
import _ from 'lodash';
import { dictWithUrl } from '@/components/lots/api.js';
import AttachmentUpload from '../components/AttachmentUpload.vue';

const defaultForm = {
    appointmentTime: '', // 预约取件日期
    appointmentTimeSlot: '', // 预约取件时间段
    appointmentChangeFirstReasonType: '', // 一级原因编码
    appointmentChangeFirstReasonValue: '', // 一级原因
    appointmentChangeSecondReasonType: '', // 二级原因编码
    appointmentChangeSecondReasonValue: '', // 二级原因编码
    remark: '',
    sendMessage: false,
    appointReasons: [],
    rollBack: false,
    operateSystem: 'TMS', // 操作系统
    propertiesList: []
};
export default {
    components: { AttachmentUpload },
    props: {
        tableData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            appointReasonOptions: [],
            appointData: _.cloneDeep(defaultForm),
            rules: {
                appointmentTimeSlot: [{ required: true, message: '请选择预约取件时间' }]
            },
            pickerOptions: {
                disabledDate (time) {
                    const serverDate = new Date(); // 获取服务器当前日期
                    const today = new Date(serverDate.getFullYear(), serverDate.getMonth(), serverDate.getDate());
                    const fiveDaysLater = new Date(serverDate.getTime() + 5 * 24 * 60 * 60 * 1000);
                    return time.getTime() < today || time.getTime() > fiveDaysLater;
                }
            },
            timeSlotOptions: [],
            currentDate: dayjs().format('YYYY-MM-DD'),
            primaryReason: {}, // 一级原因字典
            secondAppointReasons: {}, // 二级原因字典
            secondNewAppointReasons: {}, // 退货入库|拒收入库单二级原因字典
            requiredAppointReason: false
        };
    },
    methods: {
        async getAppointReason() {
            const primaryReasonRes = await dictWithUrl('REVERSE_FIRST_RESERVATION,REVERSE_SECOND_RESERVATION,REVERSE_APPOINT_TIME_ZONE').finally(() => {});
            if (primaryReasonRes) {
                this.primaryReason = _.get(primaryReasonRes, 'data.REVERSE_FIRST_RESERVATION', {});
                this.secondAppointReasons = _.get(primaryReasonRes, 'data.REVERSE_SECOND_RESERVATION', {});
                Object.entries(this.primaryReason).forEach(one => {
                    this.appointReasonOptions.push(
                        {
                            value: one[0],
                            label: one[1],
                            children: []
                        }
                    );
                });
                this.appointReasonOptions.forEach(f => {
                    Object.entries(this.secondAppointReasons).forEach(item => {
                        if (item[0] && item[0].split('_')[0] === f.value) {
                            f.children.push(
                                {
                                    value: item[0],
                                    label: item[1]
                                }
                            );
                        }
                    });
                });
                const timeSlot = _.get(primaryReasonRes, 'data.REVERSE_APPOINT_TIME_ZONE', {});

                this.getTimeSlotOptions(timeSlot);
            }
        },
        getTimeSlotOptions(timeSlot) {
            const timeSlotOptionsArr = [];
            this.timeSlotOptions = [];
            Object.entries(timeSlot).forEach(item => {
                timeSlotOptionsArr.push({
                    value: item[0],
                    label: item[1]
                });
            });
            const timeSlotOptionsArrVal = timeSlotOptionsArr.map(item => item.value).sort();
            timeSlotOptionsArrVal.forEach(item => {
                Object.entries(timeSlot).forEach(t => {
                    if (item === t[0]) {
                        this.timeSlotOptions.push({
                            value: t[0],
                            label: t[1]
                        });
                    }
                });
            });
        },
        changeVal(date) {

        },
        changeAppointmentTime (data) {
           if (!data) return false;
            this.requiredAppointReason = false;
            const appointmentTimeGreaterExamineTime = [];
            this.requiredAppointReason = false;
            this.tableData.forEach(v => {
                const examineTime = v.examineTime ? new Date(dayjs(v.examineTime).format('YYYY-MM-DD')).getTime() : 0;
                // 预约日期选择超过时效考核时间
                if (v.examineTime && (new Date(data).getTime() - examineTime > 0)) {
                    appointmentTimeGreaterExamineTime.push(v.customerOrderNo);
                }
                // 改约原因: 预约日期与最近一次预约日期对比，不同视为改约 || 时效考核日期为空,视为改约
                if (!v.examineTime || (v.appointmentTimes ? v.appointmentTimes.split(' ')[0] : '') !== data) {
                    this.requiredAppointReason = true;
                }
            });
            if (appointmentTimeGreaterExamineTime.length) {
                this.$confirm(`以下客户单号预约提货时间已超时效考核要求，请确认是否继续操作?
                订单号${appointmentTimeGreaterExamineTime.join('、')}`, '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning'
                }).then(() => {
                    this.requiredAppointReason = true;
                }).catch(() => {
                    this.appointData.appointmentTime = '';
                });
            }
        },
        changeAppointReasons (data) {
            this.appointData.appointmentChangeFirstReasonType = data[0] || '';
            this.appointData.appointmentChangeFirstReasonValue = this.primaryReason[data[0]];
            this.appointData.appointmentChangeSecondReasonType = data[1] || '';
            this.appointData.appointmentChangeSecondReasonValue = this.secondAppointReasons[data[1]];
        },
        reset () {
            this.requiredAppointReason = false;
            this.appointData = _.cloneDeep(defaultForm);
            this.$nextTick(() => {
                this.$refs.appointForm.clearValidate();
            });
        },
        checkSave() {
            this.$refs.appointForm.validate((valid) => {
                if (valid) {
                    const params = {
                        ...this.appointData,
                        sendMessage: this.appointData.sendMessage ? 1 : 0,
                        operateSystem: 'TMS',
                        operateType: 'REVERSE'// 正向订单:FORWARD 逆向订单:REVERSE
                    };
                    this.$emit('checkResult', params);
                } else {
                    this.$emit('checkResult');
                }
            });
        }
    },
    computed: {
        delieveryTimeSlotDisabled() {
            return function(item) {
                const appointmentTime = this.appointData.appointmentTime;
                if (appointmentTime && dayjs(appointmentTime).format('YYYY-MM-DD') === this.currentDate) {
                    if (item.value && item.value.split('-')[1].split(':')[0] < dayjs().hour()) return true;
                    return false;
                }
            };
        },
        propertiesList() { // 二级原因为其他时，备注必填
            return ['10_5', '20_4', '30_6'].includes(this.appointData.appointmentChangeSecondReasonType);
        }
    },
    mounted() {
        this.getAppointReason();
    }
};
</script>
<style lang="less">
.appoint-cont {
    .row-item {
        display: flex;
    }
    .appoint-reason {
        width: 100%;
    }
    .row-item-ml {
        margin-left: 10px;
    }
    .appoint-date {
        width: 100%;
    }
    .task-appoint-form-item {
        margin-bottom: 2px;
    }
    .flex-box {
        display: flex;
        align-items: center;
        .appoint-reason {
            flex: 1;
        }
    }
    .rollback-checkbox {
        margin-left: 10px;
    }
}
</style>
